import { GALLERY } from "../lib/data";

export default function TruckStrip() {
  const photos = GALLERY.map((g) => g.foto);

  return (
    <section
      aria-label="Foto armada"
      data-testid="truck-strip"
      className="overflow-hidden border-b border-zinc-800 bg-ink-900/50 py-4"
    >
      <div
        className="flex h-36 w-max animate-marquee hover:[animation-play-state:paused] sm:h-44"
        style={{ animationDuration: "55s" }}
      >
        {[0, 1].map((n) => (
          <div key={n} aria-hidden={n === 1} className="flex h-full shrink-0 items-center gap-4 pr-4">
            {photos.map((foto, i) => (
              <div
                key={`${n}-${i}`}
                className="h-full w-64 shrink-0 overflow-hidden rounded-xl border border-zinc-800 sm:w-80"
              >
                <img
                  src={foto}
                  alt="Foto armada Putra Bengawan Logistik"
                  loading="lazy"
                  className="h-full w-full object-cover"
                />
              </div>
            ))}
          </div>
        ))}
      </div>
    </section>
  );
}
